import {
  Center,
  Container,
  Box,
  Text,
  Heading,
  Stack,
  Highlight,
  Flex,
  Img,
  Spacer,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import Header from "../Header/Header";
import MockUpModel from "../../Resources/icons/modelWithBg.svg";
import { ConnectWallet } from "../../utility/metamaskModal/connectWalletModal";
import { InputModal } from "./components/InputModal";
import { EndingFooter, Footer } from "../HomePage/Footer";

const CreateEvent = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const InputModalDisclores = useDisclosure();
 
  return (
    <>
      <Header borderBottom={"10px black solid"}></Header>
      <Flex p={"10"} bg="#000" h="auto" justifyContent="center">
        <Center color={"#fff"} justifyContent={"center"}>
          <Flex
            flexWrap={"wrap-reverse"}
            align="center"
            justifyContent="center"
          >
            <Flex justifyContent={"center"} alignItems="center">
              <Stack gap={{ base: "0px", md: "5px", lg: "15px" }}>
                <Heading
                  as={"h1"}
                  fontSize={{ base: "24px", md: "40px", lg: "56px" }}
                  fontFamily={"poppins"}
                >
                  Organize Event,
                </Heading>
                <Heading
                  as={"h1"}
                  fontSize={{ base: "24px", md: "40px", lg: "56px" }}
                  fontFamily={"poppins"}
                >
                  use{" "}
                  <Highlight
                    query="NFT Tickets"
                    styles={{
                      backgroundImage:
                        "linear-gradient(89.04deg, #6A43FF 5.72%, #9A41F1 24.8%, #BE4ECF 38.67%, #E3747E 50.81%, #F6965C 63.82%, #F49948 88.96%)",
                      backgroundSize: "100%",
                      backgroundClip: "text",
                    }}
                  >
                    NFT Tickets and
                  </Highlight>
                </Heading>
                <Heading
                  as={"h1"}
                  fontSize={{ base: "24px", md: "40px", lg: "56px" }}
                  fontFamily={"poppins"}
                >
                  Verify it
                </Heading>
                <Flex padding={"10px"}>
                  <Text
                    fontFamily={"poppins"}
                    fontSize={"18px"}
                    wordBreak={"break-word"}
                  >
                    X-PASS brings Creator and Audiance together <br /> on single
                    platform
                  </Text>
                </Flex>
                <Box>
                  <Button
                    variant={"connect"}
                    onClick={InputModalDisclores.onOpen}
                  >
                    Create Event
                  </Button>
                </Box>
              </Stack>
            </Flex>
            <Box>
              <Img
                src={MockUpModel}
                maxW="650px"
                boxSize={{
                  base: "270px",
                  md: "540px",
                  lg: "-webkit-max-content",
                }}
              />
            </Box>
          </Flex>
        </Center>
      </Flex>
      {ConnectWallet({ isOpen, onOpen, onClose })}
      {InputModal(
        InputModalDisclores.isOpen,
        InputModalDisclores.onOpen,
        InputModalDisclores.onClose
      )}
      {Footer()}
      {EndingFooter()}
    </>
  );
};

export default CreateEvent;
